import { DateRangePicker, DateRangePickerProps } from 'bold-ui'
import React from 'react'

import { UseFieldProps, usePecField } from '../../final-form/hooks/useField'
import { getFieldError } from '../../final-form/util'
import { DateRangeFieldType } from './model-dateRange'
import { isDateRangeFieldEqual } from './utils-dateRange'

type DateRangeFieldProps = UseFieldProps<DateRangeFieldType> & Omit<DateRangePickerProps, 'name'>

export function DateRangeField(props: DateRangeFieldProps) {
  const { input, meta, ...rest } = usePecField({
    ...props,
    isEqual: isDateRangeFieldEqual,
  })
  return <DateRangePicker error={getFieldError(meta)} {...input} {...rest} />
}
